import { Flex } from '@chakra-ui/react';
import React from 'react';
import { BranchFiltersQueryParams } from '../hooks/useBranchesFilters';
import { Branch } from '../../../domain/branch';
import { AsyncSelector } from '../../../components/AsyncSelector';


export interface BranchesFilterProps {
  onUpdateFilters: (key: keyof BranchFiltersQueryParams, value: string[] | string | undefined) => void;
}

export const BranchesFilters = ({ onUpdateFilters }: BranchesFilterProps) => {
  return (
    <Flex flexWrap="wrap" marginBottom="xl" width="100%" justifyContent="end">
      {/*<InputGroup marginX="l" width="20em">*/}
      {/*  <InputRightElement pointerEvents="none">*/}
      {/*    <LuSearch />*/}
      {/*  </InputRightElement>*/}
      {/*  <Input placeholder="Buscar ..." />*/}
      {/*</InputGroup>*/}

      <AsyncSelector<Branch>
        handleChange={(value) => onUpdateFilters('idBranch', value?.map(branch => branch.id))}
        isMulti={true}
        url="/transactions-view/branches"
        labelProperty={'fantasy_name'}
        noSelectedLabel="Todas las sucursales"
        idProperty={'id'} />
    </Flex>
  );
};
